/*
 * FileSaver.js
 * A saveAs() FileSaver implementation.
 *
 * By Eli Grey, http://eligrey.com
 *
 * License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
 * source  : http://purl.eligrey.com/github/FileSaver.js
 */

// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999

function bom(blob, options) {
    if (options === undefined) options = { autoBom: false }
    else if (typeof options !== 'object') {
        console.warn('Deprecated: Expected third argument to be a object')
        options = { autoBom: !options }
    }

    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (
        options.autoBom &&
        /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)
    ) {
        return new Blob([String.fromCodePoint(0xfe_ff), blob], { type: blob.type })
    }
    return blob
}

function download(url, name, options) {
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.responseType = 'blob'
    xhr.addEventListener('load', function () {
        saveAs(xhr.response, name, options)
    })
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    xhr.onerror = function () {
        console.error('could not download file')
    }
    xhr.send()
}

function corsEnabled(url) {
    var xhr = new XMLHttpRequest()
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false)
    try {
        xhr.send()
    } catch {
        // no handle
    }
    return xhr.status >= 200 && xhr.status <= 299
}

// `a.click()` doesn't work for all browsers (#465)
function click(node) {
    try {
        node.click()
    } catch {
        node.dispatchEvent(new MouseEvent('click'))
    }
}

// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const userAgent = globalThis.navigator.userAgent
const isMacOSWebView =
    userAgent && /Macintosh/.test(userAgent) && /AppleWebKit/.test(userAgent) && !/Safari/.test(userAgent)

const saveAs =
    // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView
    globalThis.HTMLAnchorElement && 'download' in globalThis.HTMLAnchorElement.prototype && !isMacOSWebView
        ? function saveAs(blob, name, options) {
              const URL = globalThis.URL || globalThis.webkitURL
              const a = document.createElement('a')
              name = name || blob.name || 'download'

              a.download = name
              a.rel = 'noopener'

              a.target = '_blank'

              if (typeof blob === 'string') {
                  // Support regular links
                  a.href = blob
                  if (a.origin === location.origin) {
                      click(a)
                  } else {
                      corsEnabled(a.href) ? download(blob, name, options) : click(a, (a.target = '_blank'))
                  }
              } else {
                  // Support blobs
                  a.href = URL.createObjectURL(blob)
                  setTimeout(function () {
                      URL.revokeObjectURL(a.href)
                  }, 4e4) // 40s
                  setTimeout(function () {
                      click(a)
                  }, 0)
              }
          }
        : // Use msSaveOrOpenBlob as a second approach
          globalThis.navigator && 'msSaveOrOpenBlob' in navigator
          ? function saveAs(blob, name, options) {
                name = name || blob.name || 'download'

                if (typeof blob === 'string') {
                    if (corsEnabled(blob)) {
                        download(blob, name, options)
                    } else {
                        var a = document.createElement('a')
                        a.href = blob
                        a.target = '_blank'
                        setTimeout(function () {
                            click(a)
                        })
                    }
                } else {
                    navigator.msSaveOrOpenBlob(bom(blob, options), name)
                }
            }
          : // Fallback to using FileReader and a popup
            function saveAs(blob, name, options, popup) {
                // Open a popup immediately do go around popup blocker
                // Mostly only available on user interaction and the fileReader is async so...
                popup = popup || open('', '_blank')
                if (popup) {
                    popup.document.title = popup.document.body.textContent = 'downloading...'
                }

                if (typeof blob === 'string') return download(blob, name, options)

                var force = blob.type === 'application/octet-stream'
                var isSafari = /constructor/i.test(globalThis.HTMLElement) || globalThis.safari
                var isChromeIOS = /CriOS\/\d+/.test(userAgent)

                if ((isChromeIOS || (force && isSafari) || isMacOSWebView) && typeof FileReader !== 'undefined') {
                    // Safari doesn't allow downloading of blob URLs
                    var reader = new FileReader()
                    reader.onloadend = function () {
                        var url = reader.result
                        url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;')
                        if (popup) popup.location.href = url
                        else location = url
                        popup = undefined // reverse-tabnabbing #460
                    }
                    reader.readAsDataURL(blob)
                } else {
                    var URL = globalThis.URL || globalThis.webkitURL
                    var url = URL.createObjectURL(blob)
                    if (popup) popup.location = url
                    else location.href = url
                    popup = undefined // reverse-tabnabbing #460
                    setTimeout(function () {
                        URL.revokeObjectURL(url)
                    }, 4e4) // 40s
                }
            }

export default saveAs
